/* eslint-disable jsx-a11y/anchor-is-valid */
import {useEffect, useState} from 'react'
import {Redirect, Route, Switch, useHistory, useLocation} from 'react-router-dom'
import {Registration} from './components/Registration'
import {ForgotPassword} from './components/ForgotPassword'
import {Login} from './components/Login'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {ChangePassword} from './components/ChangePassword'
import {CreatePinCode} from './components/CreatePinCode'

export function AuthPage() {
  const [userId, setUserId] = useState('')
  const [code, setCode] = useState('')
  let history = useHistory()
  const query = new URLSearchParams(useLocation().search)

  useEffect(() => {
    if (query.get('userId')) setUserId(query.get('userId') || '')
  }, [query.get('userId')])

  useEffect(() => {
    if (query.get('code')) {
      let test = query.get('code') || ''
      setCode(encodeURIComponent(test) || '')
    }
  }, [query.get('code')])

  useEffect(() => {
    document.body.classList.add('bg-white')
    return () => {
      document.body.classList.remove('bg-white')
    }
  }, [])

  return (
    <div
      className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'
      style={{
        backgroundImage: `url(${toAbsoluteUrl('/media/illustrations/sketchy-1/14.png')})`,
      }}
    >
      <div className='d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20'>
        {/* <a href='#' className='mb-12'>
          <img alt='Logo' src={toAbsoluteUrl('/media/logos/logo-tmiv.png')} className='h-80px' />
        </a> */}
        <div className='w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto'>
          <Switch>
            <Route path='/auth/login' component={Login} />
            <Route path='/auth/registration'>
              <Registration userId={userId} code={code} />
            </Route>
            <Route path='/auth/forgot-password' component={ForgotPassword} />
            <Route path='/auth/change-password' component={ChangePassword} />
            <Route path='/auth/create-pin-code'>
              <CreatePinCode type='' />
            </Route>
            <Redirect from='/auth' exact={true} to='/auth/login' />
            <Redirect to='/auth/login' />
          </Switch>
        </div>
      </div>
    </div>
  )
}
